import e from "react";
import { useTranslation as s } from "react-i18next";
import a from "./cashbackRecord.module.scss.js";
function i({
  record: c,
  design: r
}) {
  var t;
  const { t: o } = s();
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": "cashback-record",
      className: a.cashbackRecord,
      style: {
        "--chipBackgroundColor": r.chipBackgroundColor,
        "--chipForegroundColor": r.chipForegroundColor
      }
    },
    /* @__PURE__ */ e.createElement("div", { className: a.cashbackRecord__wrapper }, /* @__PURE__ */ e.createElement("div", { className: a.cashbackRecord__infoRow }, /* @__PURE__ */ e.createElement("div", { className: a.cashbackRecord__infoRow__date }, c.getFormattedTimestamp()), /* @__PURE__ */ e.createElement("div", { className: a.cashbackRecord__infoRow__text }, (t = c.order) != null && t.id ? `#${c.order.ticketNumber ?? c.order.id}` : o("orderRecord.anonOrderText"))), /* @__PURE__ */ e.createElement("div", { className: a.cashbackRecord__values }, /* @__PURE__ */ e.createElement("div", { className: a.cashbackRecord__values__value }, `${c.value > 0 ? "+" : ""}${c.getFormattedValue("EUR")}`)))
  );
}
export {
  i as CashbackRecord
};
//# sourceMappingURL=CashbackRecord.js.map
